import { getAgentDisplayPicUrl } from "../../../utilities/conversions";

type ActivityModuleProps = {
    filter: string,
    currentUser: any,
    client: any,
    recentAgents: any,
    agentsLoading: boolean,
    setTab: (tab: string) => void,
    baseUrl: string,
}
export default function ActivityModule({ filter, currentUser, client, recentAgents, agentsLoading, setTab, baseUrl }: ActivityModuleProps) {

    const handleNavigation = (to: string) => {
        setTab(to);
        localStorage.setItem("previousPage", "Dashboard");
    }
    return (
        <div className="bg-white rounded-2xl border border-slate-100 p-6 shadow-sm space-y-5 h-[290px] overflow-y-auto">
            <div className="flex items-center justify-between">
                <h2 className="text-sm font-semibold">Aktivitet nå</h2>
                <div className="flex items-center gap-2 ml-auto">
                    <button onClick={() => handleNavigation("Agenter")} className="text-xs text-indigo-600 hover:underline">Se alle</button>
                    <span className="text-[11px] px-2 py-1 rounded-full bg-emerald-50 text-emerald-700">Live</span>
                </div>
            </div>

            <ul className="space-y-3 text-sm">

                {agentsLoading ? (
                    <div className="flex items-center justify-center h-64 w-full">
                        <div className="flex flex-col items-center">
                            <div className="w-12 h-12 border-4 border-purple-400 border-t-transparent rounded-full animate-spin"></div>
                            <p className="mt-3 text-gray-600 animate-pulse">Laster...</p>
                        </div>
                    </div>
                ) : (
                    recentAgents?.map((a: any) => (
                        <li key={a.uid} className="flex items-center justify-between">

                            <div className="flex items-center gap-3">
                                <div className="w-8 h-8 rounded-full bg-slate-200 overflow-hidden">
                                    <img
                                        src={getAgentDisplayPicUrl(a?.display_pic, baseUrl)}
                                        alt={a.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div>
                                    <p onClick={() => handleNavigation("Agent detail")} className="font-medium text-sm cursor-pointer">{a.name}</p>
                                    <p className="text-[11px] text-slate-500">{a.minutes} min i {filter}</p>
                                </div>
                            </div>

                            <div className="flex flex-col items-end gap-1">
                                <span
                                    className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium ${a.call_status === "busy"
                                        ? "bg-red-50 text-red-700"
                                        : a.call_status === "available"
                                            ? "bg-emerald-50 text-emerald-700"
                                            : "bg-slate-100 text-slate-500"
                                        }`}
                                >
                                    {a.call_status}
                                </span>
                                <span className="text-[11px] text-slate-500">{a.revenue}</span>
                            </div>

                        </li>
                    ))
                )}
            </ul>
        </div>
    )
}